import React, { useState } from 'react';
import { Box, TextField, Typography } from '@mui/material';

export default function EditableTableCell({ 
  value,
  onChange,
  type = 'text',
  disabled = false,
  startAdornment,
  endAdornment,
  inputProps = {},
  align = 'left'
}) {
  const [isEditing, setIsEditing] = useState(false);
  const [tempValue, setTempValue] = useState(value);

  const handleDoubleClick = () => {
    if (!disabled) {
      setIsEditing(true);
      setTempValue(value);
    }
  };

  const handleBlur = () => {
    setIsEditing(false);
    onChange(tempValue);
  };

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      handleBlur();
    } else if (e.key === 'Escape') {
      setIsEditing(false);
      setTempValue(value);
    }
  };

  return (
    <Box 
      onDoubleClick={handleDoubleClick} 
      sx={{ 
        p: 1,
        cursor: disabled ? 'default' : 'pointer',
        '&:hover': {
          bgcolor: disabled ? 'transparent' : 'action.hover'
        },
        textAlign: align
      }}
    >
      {isEditing ? (
        <TextField
          autoFocus
          size="small"
          type={type}
          value={tempValue}
          onChange={(e) => setTempValue(e.target.value)}
          onBlur={handleBlur}
          onKeyDown={handleKeyPress}
          InputProps={{
            startAdornment,
            endAdornment,
            ...inputProps
          }}
          sx={{ width: '100%' }}
        />
      ) : (
        <Typography>
          {startAdornment}{value}{endAdornment}
        </Typography>
      )}
    </Box>
  );
}